import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import persistedState from 'vuex-persistedstate'
export default new Vuex.Store({
    plugins: [persistedState(
        {
            storage: window.sessionStorage
        }
    )],
    state: {
        token: '',
        userPhone: '',
        currentPileCode:'',
        userInfo: {},
        screenWidth: '',
        isApple: '',
        bannerUrl: '',
        themeName: 'white',
        reconfig:false, // 重构
    },
    mutations: {
        // 设置token
        setToken(state, token) {
            state.token = token;
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo
        },
        setScreenWidth(state, screenWidth){
            state.screenWidth = screenWidth
        },
        setPhone(state, userPhone){
            state.userPhone = userPhone;
        },
        setCurrentPileCode(state, currentPileCode){
            state.currentPileCode = currentPileCode;
        },
        setApple(state, isApple){
            state.isApple = isApple;
        },
        setBannerUrl(state, bannerUrl){
            state.bannerUrl = bannerUrl
        },
        setThemeName(state, themeName){
            state.themeName = themeName
        },
        setReconfig(state,val){
            state.reconfig = val;
        }
    },
    actions: {},
    modules: {}
})
